import { supabase } from './supabase'

export async function vwapRequest({ id, symbol, body, signal, events = false, after = 0, ownerId } = {}) {
  const { data: { session } } = await supabase.auth.getSession()
  signal?.throwIfAborted()
  if (!session) throw new Error('Sign in to use saved VWAPs')
  if (ownerId && session.user?.id !== ownerId) throw new Error('VWAP account changed')
  const response = await fetch(`/api/ibkr/vwap${id ? `?id=${encodeURIComponent(id)}` : events ? `?events=1&after=${encodeURIComponent(after)}` : symbol ? `?symbol=${encodeURIComponent(symbol)}` : ''}`, {
    method: body ? 'POST' : 'GET', signal,
    headers: { Authorization: `Bearer ${session.access_token}`, 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  })
  const value = await response.json()
  if (!response.ok) throw new Error(value.error || 'VWAP is unavailable')
  return value
}
